import AddMovie from './AddMovie';

export default AddMovie;
